import { lazyMountAndShowFullOptions } from 'owa-options-view';

export async function openDirectivesSettings(): Promise<void> {
    lazyMountAndShowFullOptions.importAndExecute('copilot', 'calendarInstructions');
}
